export default "__VITE_ASSET__C2Brw5zK__"